import { render, staticRenderFns } from "./ModifierItemForm.vue?vue&type=template&id=67b64657"
import script from "./ModifierItemForm.vue?vue&type=script&lang=ts"
export * from "./ModifierItemForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports